import { articleGraphQL } from '@/query/article/render-article'

const createQuery = () => `
  ... on CompanyArticleSectionWidget {
    id
    articleType
    display
    items {
      ${articleGraphQL}
    }
  }
`

export default createQuery
